import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";
import { IPositionsWithChangeRequestsStatus } from "@/Washouts/types/WashoutReview";

export async function getWashoutsPayPeriodTree({
	commissionCycleId,
	payPeriodId,
	locationId,
}: {
	commissionCycleId: string;
	payPeriodId: string;
	locationId: string;
}) {
	const query = gql`
		query getWashoutsPayPeriodTree($commissionCycleId: String!, $payPeriodId: String!, $locationId: String!) {
			getWashoutsPayPeriodTree(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, locationId: $locationId) {
				_id
				title
				unreviewable
				disabled
				list {
					_id
					userId
					title
					position
					commissionCycleId
					payPeriodId
					currentPayPlanAssignmentId
					upcomingPayPlanAssignmentId
					hasWashout
					reviewed
					list {
						_id
						userId
						title
						position
						commissionCycleId
						payPeriodId
						currentPayPlanAssignmentId
						upcomingPayPlanAssignmentId
						hasWashout
						unreviewable
						reviewed
						disabled
						# tooltip {
						# 	title
						# }
					}
				}
			}
		}
	`;

	const variables = {
		commissionCycleId,
		payPeriodId,
		locationId,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data.data?.getWashoutsPayPeriodTree;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
}

export const getChatAttachmentsPresignedUrl = async ({
	locationId,
	commissionCycleId,
	payPeriodId,
	requestId,
	file,
	action = "putObject",
}: {
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	requestId: string;
	file: { name: string };
	action?: string;
}) => {
	const query = gql`
		query getChatAttachmentsPresignedUrl(
			$locationId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$requestId: String!
			$fileName: String
			$action: String
		) {
			getChatAttachmentsPresignedUrl(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				requestId: $requestId
				fileName: $fileName
				action: $action
			) {
				fileName
				presignedUrl
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		requestId,
		action,
		fileName: file.name,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data?.data?.getChatAttachmentsPresignedUrl;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
};

export const getPositionsWithChangeRequestsStatus = async ({
	locationId,
	commissionCycleId,
	payPeriodId,
}: {
	locationId: string;
	commissionCycleId?: string;
	payPeriodId: string;
}) => {
	const query = gql`
		query getPositionsWithChangeRequestsStatus($locationId: String!, $commissionCycleId: String, $payPeriodId: String!) {
			getPositionsWithChangeRequestsStatus(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
			) {
				locationId
				commissionCycleId
				payPeriodId
				positions {
					position
					pendingRequestIds
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
	};

	try {
		const response: GraphqlQueryResponse<"getPositionsWithChangeRequestsStatus", IPositionsWithChangeRequestsStatus> =
			await apiInstance.post("/graphql", {
				query,
				variables,
			});
		return response.data?.data?.getPositionsWithChangeRequestsStatus;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
};
